import React from 'react';
import { CtaButton } from './CtaButton';
interface PricingCardsProps {
  compact?: boolean;
}
export function PricingCards({
  compact = false
}: PricingCardsProps) {
  return <div className="grid gap-6 md:grid-cols-2" data-id="element-163" data-mp="21f4ft53f8abg">
      <div className="flex flex-col rounded-2xl border border-[var(--violet)]/50 bg-[#0d0819] p-6 sm:p-8" data-id="element-164" data-mp="21ecx2uuxa72l">
        <div className="mb-4 flex items-center gap-2" data-id="element-165" data-mp="26fsemcxw5vg8">
          <span aria-hidden="true" data-id="element-166" data-mp="2bdty2yz8bws8">🦋</span>
          <h3 className="font-display text-2xl font-bold text-[var(--cream)]" data-id="element-167" data-mp="2bcsl2oynl07v">
            Sistema Keto 365
          </h3>
        </div>
        <p className="mb-6 text-sm text-white/60" data-id="element-168" data-mp="2k5m3gv9ecfpy">
          6 Tomos + 6 Bonos · Todo el año resuelto
        </p>
        <div className="mb-6 mt-auto" data-id="element-169" data-mp="2p4fhcosli8qn">
          <p className="text-lg text-white/40 line-through" data-id="element-170" data-mp="2p476f2g19di3">$29.990</p>
          <p className="font-display text-4xl font-extrabold text-[var(--cream)] sm:text-5xl" data-id="element-171" data-mp="2u4l4psru192x">
            $19.990 <span className="text-xl text-[var(--lilac)]" data-id="element-172" data-mp="2z23ibwgsoch9">ARS</span>
          </p>
        </div>
        <CtaButton href="https://www.sistemaketo.store/cart/48132891344948:1" variant="outline" size={compact ? 'md' : 'lg'} data-id="element-173" data-mp="3th686yg4bhdw">
          Quiero el Sistema Keto 365
        </CtaButton>
      </div>

      <div className="relative flex flex-col rounded-2xl border-2 border-[var(--lilac)] bg-[#16102e] p-6 shadow-[0_0_40px_-12px_rgba(167,139,250,0.6)] sm:p-8" data-id="element-174" data-mp="3jj8j68qfpgk8">
        <span className="absolute -top-3 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-[var(--lilac)] px-4 py-1 text-xs font-extrabold uppercase tracking-wide text-black" data-id="element-175" data-mp="g2jfqvm5emys">
          ⭐ Más elegido
        </span>
        <div className="mb-4 flex items-center gap-2" data-id="element-176" data-mp="6avqn1d2di0h">
          <span aria-hidden="true" data-id="element-177" data-mp="2av1aloffmen">⚡</span>
          <h3 className="font-display text-2xl font-bold text-[var(--cream)]" data-id="element-178" data-mp="29tr0jf8j3xz">
            Sistema Keto 365 + Keto Turbo
          </h3>
        </div>
        <p className="mb-6 text-sm text-white/60" data-id="element-179" data-mp="u1stzpqsn704">
          6 Tomos + 6 Bonos + Protocolo de aceleración metabólica
        </p>
        <div className="mb-6 mt-auto" data-id="element-180" data-mp="2o9d4gvzb6bov">
          <p className="text-lg text-white/40 line-through" data-id="element-181" data-mp="2oaep9s64mcjs">$39.990</p>
          <p className="font-display text-4xl font-extrabold text-[var(--lilac-light)] sm:text-5xl" data-id="element-182" data-mp="2t7og9c95yw9q">
            $27.990 <span className="text-xl text-[var(--lilac)]" data-id="element-183" data-mp="2ejadf1bqz7t6">ARS</span>
          </p>
        </div>
        <CtaButton href="https://www.sistemaketo.store/cart/48132893868084:1" variant="lilac" size={compact ? 'md' : 'lg'} data-id="element-184" data-mp="2jhlm38qb3c9t">
          Quiero el Sistema + Keto Turbo
        </CtaButton>
      </div>
    </div>;
}